import { defineStore } from 'pinia'
import API from '../api/index'

export const useFeeTypesStore = defineStore('feeTypes', {
  
    state: () => ({
    
        fee_types: [],

        isLoading: false

    }),

  actions: {

    async fetch_fee_types() {
      
    if (this.fee_types.length > 0) return // If we already have data, don't fetch again (caching)

    this.isLoading = true

    const res = await API.fetch_fee_types()
    
    this.fee_types = res.data || []

    this.isLoading = false

     
    },
    // Helper to add a new fee type to the store immediately after creation
    // so we don't have to refetch the whole list
    add_fee_type_to_store(new_fee_type) {
      this.fee_types.push(new_fee_type)
    },

    // Helper to remove from store immediately after deletion
    remove_fee_type_from_store(id) {
      this.fee_types = this.fee_types.filter(f => f.id !== id)
    }
  }
})